import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Avisa o JivoChat a cada troca de rota da SPA (o widget só carrega em produção, ver public/index.html)
const JivoPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // pequeno atraso para o document.title já refletir a nova tela
    const timer = setTimeout(() => {
      if (window.jivo_api && typeof window.jivo_api.sendPageTitle === "function") {
        window.jivo_api.sendPageTitle(document.title, true, window.location.href);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default JivoPageTracker;
